import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import tr from './locales/tr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';
import it from './locales/it.json';
import fr from './locales/fr.json';
import fi from './locales/fi.json';
import fa from './locales/fa.json';
import ar from './locales/ar.json';
import es from './locales/es.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
      de: { translation: de },
      ru: { translation: ru },
      zh: { translation: zh },
      it: { translation: it },
      fr: { translation: fr },
      fi: { translation: fi },
      fa: { translation: fa },
      ar: { translation: ar },
      es: { translation: es },
    },
    lng: 'tr',
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
